// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseTrainingDataExportData } from './genericApiResponseTrainingDataExportData';
import type { GenericApiResponseTrainingDataExportMessage } from './genericApiResponseTrainingDataExportMessage';
import type { GenericApiResponseTrainingDataExportPagination } from './genericApiResponseTrainingDataExportPagination';
import type { GenericApiResponseTrainingDataExportError } from './genericApiResponseTrainingDataExportError';

export interface GenericApiResponseTrainingDataExport {
  data?: GenericApiResponseTrainingDataExportData;
  message?: GenericApiResponseTrainingDataExportMessage;
  pagination?: GenericApiResponseTrainingDataExportPagination;
  error?: GenericApiResponseTrainingDataExportError;
  statusCode?: number;
}
